import React from "react";
import checkedIcon from "../../../assets/images/checked.png";

const DoneStep = ({ copy, onReview }) => (
  <section className="estate-mapping__welcome">
    <div className="estate-mapping__welcome-icon estate-mapping__welcome-icon--done"><img alt="" src={checkedIcon} /></div>
    <h1>{copy.done.title}</h1>
    <p>{copy.done.body}</p>
    <button className="estate-mapping__button estate-mapping__button--secondary" onClick={onReview}>{copy.done.review}</button>
  </section>
);

export default DoneStep;
